import BaseCadastro from "components/BaseCadastro";
import { useToastContext } from "components/alert/ToastContext";
import { Label } from "components/input/Label";
import Usuario from "model/administracao/cadastro/Usuario";
import CategoriaDocumento from "model/documentos/CategoriaDocumento";
import { AutoComplete } from "primereact/autocomplete";
import { Checkbox } from "primereact/checkbox";
import { InputText } from "primereact/inputtext";
import { useEffect, useState } from "react";
import "react-hook-form";
import { useForm } from "react-hook-form";
import { useSearchParams } from "react-router-dom";
import CategoriaDocumentoService from "service/documentos/CategoriaDocumentoService";
import { usuarioCompleteMethod, usuarioItemTemplate } from "utils/autocompleteUtils";

const categoriaDocumentoService = new CategoriaDocumentoService();

export default function CategoriaDocumentoCadastro() {

    const { clearErrors, setError, register, formState: { errors } } = useForm();

    const [categoriaDocumento, setCategoriaDocumento] = useState<CategoriaDocumento>(new CategoriaDocumento());
    const [titulo, setTitulo] = useState<string>('Categoria');

    const [usuarios, setUsuarios] = useState<Usuario[]>([]);
    const [usuariosFiltrados, setUsuariosFiltrados] = useState<Usuario[]>([]);

    useEffect(() => {
        categoriaDocumentoService.usuarios().then(json => {
            setUsuarios([new Usuario(0, null, "Selecione um Usuário"), ...json]);
        }).catch(e => {
            console.error(e);
        });
    }, []);

    function validar() {
        if (!categoriaDocumento.prefixo) {
            setError("prefixo", { type: "manual", message: "Prefixo é Obrigatório" }, { shouldFocus: true })
            return false;
        }
        if (!categoriaDocumento.nome) {
            setError("nome", { type: "manual", message: "Nome é Obrigatório" }, { shouldFocus: true })
            return false;
        }
        return true;
    }

    return (

        <BaseCadastro model={categoriaDocumento} service={categoriaDocumentoService} setModel={(value: CategoriaDocumento) => setCategoriaDocumento(value)} novoCadastro getNewModel={() => new CategoriaDocumento()}
            validar={() => validar()} urlService="/categoriaDocumento" pathCadastro="/categoriaDocumento" tituloPagina={titulo}
        >

            {titulo ?
                <div className="row">
                    <label style={{ fontSize: 18, fontWeight: 'bold' }} className="col col-sm-12">{titulo}</label>
                </div>
                : null}

            <div style={{ display: "flex", marginTop: 4 }}>
                <Checkbox
                    checked={categoriaDocumento.temAprovacao}
                    onChange={(e) => { setCategoriaDocumento({ ...categoriaDocumento, temAprovacao: e.checked as boolean }) }}
                    style={{ marginRight: 5 }}
                />
                <label>Tem aprovação</label>
            </div>
            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Prefixo</Label>
                <div className="col-sm-12">
                    <InputText
                        className={errors.prefixo ? "p-invalid" : ""}
                        required value={categoriaDocumento.prefixo}
                        style={{ width: '30%' }}
                        {...register("prefixo", {
                            onChange: (e) => {
                                setCategoriaDocumento({ ...categoriaDocumento, prefixo: e.target.value })
                                clearErrors("prefixo")
                            }
                        })}
                    />
                </div>
                {errors.prefixo && errors.prefixo.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.prefixo?.message as string}</span> : null}
            </div>

            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Nome</Label>
                <div className="col-sm-12">
                    <InputText
                        className={errors.nome ? "p-invalid" : ""}
                        required value={categoriaDocumento.nome}
                        style={{ width: '30%' }}
                        {...register("nome", {
                            onChange: (e) => {
                                setCategoriaDocumento({ ...categoriaDocumento, nome: e.target.value })
                                clearErrors("nome")
                            }
                        })}
                    />
                </div>
                {errors.nome && errors.nome.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.nome?.message as string}</span> : null}
            </div>

            <div className="row">
                <Label className="col col-sm-12">Responsável pela distribuição</Label>
                <div className="col-sm-12">
                    <AutoComplete
                        dropdown
                        value={categoriaDocumento.responsavelDistribuicao}
                        placeholder="Selecione um Usuário"
                        style={{ width: '30%' }}
                        field="nome"
                        itemTemplate={(item: Usuario) => usuarioItemTemplate(item)}
                        suggestions={usuariosFiltrados}
                        completeMethod={(e) => {
                            let filtered: Usuario[] = usuarioCompleteMethod(usuarios, e.query);
                            setUsuariosFiltrados(filtered);
                        }}
                        onChange={(e) => {
                            let categoriaLocal = JSON.parse(JSON.stringify(categoriaDocumento));
                            if (!e.target.value) {
                                categoriaLocal.responsavelDistribuicao = null;
                            } else if (typeof e.target.value == "string") {
                                let usuario = new Usuario();
                                usuario.nome = e.target.value;
                                categoriaLocal.responsavelDistribuicao = usuario;
                            } else {
                                categoriaLocal.responsavelDistribuicao = e.target.value;
                            }
                            setCategoriaDocumento(categoriaLocal);
                        }}
                    />
                </div>
            </div>

            <div className="row">
                <Label className="col col-sm-12">Revisor padrão</Label>
                <div className="col-sm-12">
                    <AutoComplete
                        dropdown
                        value={categoriaDocumento.revisorPadrao}
                        placeholder="Selecione um Usuário"
                        style={{ width: '30%' }}
                        field="nome"
                        itemTemplate={(item: Usuario) => usuarioItemTemplate(item)}
                        suggestions={usuariosFiltrados}
                        completeMethod={(e) => {
                            let filtered: Usuario[] = usuarioCompleteMethod(usuarios, e.query);
                            setUsuariosFiltrados(filtered);
                        }}
                        onChange={(e) => {
                            let categoriaLocal = JSON.parse(JSON.stringify(categoriaDocumento));
                            if (!e.target.value) {
                                categoriaLocal.revisorPadrao = null;
                            } else if (typeof e.target.value == "string") {
                                let usuario = new Usuario();
                                usuario.nome = e.target.value;
                                categoriaLocal.revisorPadrao = usuario;
                            } else {
                                categoriaLocal.revisorPadrao = e.target.value;
                            }
                            setCategoriaDocumento(categoriaLocal);
                        }}
                    />
                </div>
            </div>

            <div className="row">
                <Label className="col col-sm-12">Aprovador padrão</Label>
                <div className="col-sm-12">
                    <AutoComplete
                        dropdown
                        value={categoriaDocumento.aprovadorPadrao}
                        placeholder="Selecione um Usuário"
                        style={{ width: '30%' }}
                        field="nome"
                        itemTemplate={(item: Usuario) => usuarioItemTemplate(item)}
                        suggestions={usuariosFiltrados}
                        completeMethod={(e) => {
                            let filtered: Usuario[] = usuarioCompleteMethod(usuarios, e.query);
                            setUsuariosFiltrados(filtered);
                        }}
                        onChange={(e) => {
                            let categoriaLocal = JSON.parse(JSON.stringify(categoriaDocumento));
                            if (!e.target.value) {
                                categoriaLocal.aprovadorPadrao = null;
                            } else if (typeof e.target.value == "string") {
                                let usuario = new Usuario();
                                usuario.nome = e.target.value;
                                categoriaLocal.aprovadorPadrao = usuario;
                            } else {
                                categoriaLocal.aprovadorPadrao = e.target.value;
                            }
                            setCategoriaDocumento(categoriaLocal);
                        }}
                    />
                </div>
            </div>

        </BaseCadastro>
    )
}
